<template>
    <div>
        <compWrapper :title="$t('global.common.base_information', { defaultValue: '基本信息' })" theme="primary">
            <compFormQuery
                v-if="type=='query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="140"
				placeholder="--">
            </compFormQuery>

            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="140">
            </compFormEdit>
            <template v-if="type!='query'" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
				<vButton class="margin-right-20" @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
			</template>
        </compWrapper>
        <compWrapper :title="$t('global.common.operate_history',{defaultValue:'操作历史'})" theme="gray" v-if="type==='query'">
			<compLog class="margin-layout" :data="logList" :columns="logcolumn"></compLog>
		</compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpGetMinimumChargeOne, HttpUpdateMinimumChargeOne, HttpSaveMinimumChargeOne } from '@/service/account';
import { HttpOtherLogiServiceList,HttpGetCarrierGroupByOrg } from "@/service/carrieraccount";
import { HttpGetServiceList, HttpGetServiceProductList } from "@/service/fedex";
import { HttpProductList } from '@mods/service/dictionary';
import { mapGetters } from 'vuex';
import mixin from "../mixin"
export default {
    props:['activeid','querytype'],
    mixins: [mixin],
    data(){
        return {
            type: this.$route.params.type || this.querytype,
			id: this.$route.query.id || this.activeid,
            logList:[],
            groupList:[],
            groupServiceList:[],
            formData:{
                regionCode: '',
            },
            loading:false,
            sourproductList:[],
        }
    },
    components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
	},
    created(){
        this.getDetail();
        // this.getGroupServiceList(0);
    },
    computed:{
        ...mapGetters('dictionary', ['getNextOrgList','getCarrierServiceList','getCusproductList','getCountryList']),
        getBase(){
            return [
                {
                    label: this.$t('global.common.organization', { defaultValue: '组织' }),
                    key: "organizationId",
                    tag:'vSelect',
                    options:this.getNextOrgList,
                    props:{
                        filterable:true
                    },
                    on:{
                        'on-change':(val)=>{
                            this.formData.lineId = '';
                            this.formData.groupId = '';
                            this.formData.carrierServiceId = '';
                            if(val){
                                this.getOrgGroupList(val);
                            }else{
                                this.groupList = [];
                                this.sourproductList = [];
                            }
                        }
                    },
                    query:this.type!='add'
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'lineId',
                    show:true,
                    options:this.sourproductList.map(item =>{
                        return {
                            label:item.name,
                            value:item.id
                        }
                    }),
                    props:{
                        filterable:true,
                    },
                    required:false,
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code', { defaultValue: '物流商' }),
                    label: "物流产品",
                    key: "groupId",
                    tag: 'Select',
                    options:this.groupList,
                    props:{
                        filterable:true
                    },
                    on:{
                        'on-change':(val)=>{
                            this.formData.carrierServiceId = '';
                            if(val){
                                this.getGroupServiceList(val);
                            }else{
                                this.groupServiceList = []
                            }
                        }
                    },
                    show: this.type == 'add',
                },
                {
                    label: "物流产品",
                    key: "groupName",
                    show: this.type !== 'add',
                    query: true,
                },
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    key: "carrierServiceId",
                    tag: 'Select',
                    options:this.groupServiceList,
                    props:{
                        filterable:true,
                    },
                    // on:{
                    //     'on-change':(val)=>{
                    //         this.getRegionCountry(val)
                    //     }
                    // },
                    show: this.type == 'add',
                },
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    key: "carrierServiceCode",
                    show: this.type !== 'add',
                    query: true,
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    query:true,
                    tag: "div",
                    children: (h) => {
                        const region=this.getCountryList.filter(item=>item.value===this.formData.regionCode)[0]
                        return (
                            <div class="font-bold">
                                {region ? region.label : "--"}
                            </div>
                        );
                    },
                    show:this.type!=='query',
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    key:'regionCode',
                    render: (h) => {
                        const regionCountry=this.getCountryList.filter(item=>item.value===this.formData.regionCode)[0]
                        return regionCountry?regionCountry.label:'--'
                    },
                    show:this.type==='query'
                },
                // {
                //     label: this.$t('fbb.alloment.carrier_server', { defaultValue: '承运商服务' }),
                //     key: "carrierServiceId",
                //     tag:'Select',
                //     options:this.getCarrierServiceList,
                //     props:{
                //         filterable:true
                //     },
                //     query:this.type!='add'
                // },
                {
                    label: this.$t('fbb.account.cusdisacountrate_weight_min', { defaultValue: '重量区间最小值(lbs)' }),
                    key: "weightRangeMin",
                },
                {
                    label: this.$t('fbb.account.cusdisacountrate_weight_max', { defaultValue: '重量区间最大值(lbs)' }),
                    key: "weightRangeMax",
                },
                {
                    label: this.$t('fbb.customerMinimumCharges.minCost', { defaultValue: '最低收费(usd)' }),
                    key: "cost",
                },
                {
                    label:'生效开始日期',
                    key:'startTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
                {
                    label:'生效结束日期',
                    key:'endTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
            ]
        },
    },
    methods:{
        getRegionCountry(val){
            const groupService=this.groupList.filter(item=>{
                return item.value==val
            })
            this.formData.regionCode=groupService[0]?groupService[0].attach.regionCode:''
        },
        getOrgGroupList(val) {
            HttpGetServiceList({
            // HttpGetCarrierGroupByOrg({
                // contextId:global.SYSID,
                customerId: val,
            }).then(
                (res) => {
                    this.groupList = res.data.map(item => {
                        return {
                            value: item.id,
                            label: item.carrierGroupCode,
                            attach: {
                                ...item
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            HttpProductList({
                contextId:val
            }).then(res=>{
                // console.log(res.data)
                this.sourproductList = res.data
            })
        },
        getGroupServiceList(val) {
            HttpGetServiceProductList({
            // HttpOtherLogiServiceList({
                contextId:global.SYSID,
                carrierGroupId: val,
                orgId: this.formData.organizationId,
            }).then(
                (res) => {
                    this.groupServiceList = res.data.map(item => {
                        return {
                            value: item.id,
                            label: item.code,
                            attach: {
                                ...item
                            },
                        };
                    });
                    this.getRegionCountry(val)
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        getDetail(){
            if(this.type == 'add') return
            this.loading = true;
            HttpGetMinimumChargeOne({
                id:this.id
            }).then(res=>{
                this.formData = res.data.customerMinimumChargesEntity;
                this.logList = res.data.updateLogEntities;
                this.getGroupServiceList(this.formData.groupId);
                this.getOrgGroupList(this.formData.organizationId);
                this.loading = false;
            },err=>{
                this.$VMessage.error(err.message)
            })
        },
        async submit(){
            const valid = await this.$refs.editform.validate()
            if (!valid) return;

            this.loading = true;
            if(this.type == 'add'){
                HttpSaveMinimumChargeOne({
                    ...this.formData
                }).then(res=>{
                    this.$VMessage.success(res.message)
                    this.loading = false;
                    this.cancel();
                },err=>{
                    this.$VMessage.error(err.message)
                    this.loading = false;
                })
            }else{
                HttpUpdateMinimumChargeOne({
                    id:this.id,
                    organizationId:this.formData.organizationId,
                    carrierServiceId:this.formData.carrierServiceId,
                    weightRangeMin:this.formData.weightRangeMin,
                    weightRangeMax:this.formData.weightRangeMax,
                    cost:this.formData.cost,
                    startTime:this.formData.startTime,
                    endTime:this.formData.endTime
                }).then(res=>{
                    this.$VMessage.success(res.message)
                    this.loading = false;
                    this.cancel();
                },err=>{
                    this.$VMessage.error(err.message)
                    this.loading = false;
                })
            }
        },
        cancel(){
            this.$router.push({ name: 'cusminimuncostList' });
        }
    }
}
</script>
